import { useAuth } from "../../context/contextAuth.js";
import { useDesign } from "../../context/contextDesign.js";
import { useProfile } from "../../context/contextProfile.js";
import { useNetwork } from "../../context/Dashboard/contextNetwork.js";
import { useEffect, useState } from "react";
import RiskExposureListPlaceholder from "../../components/cards/data-card/RiskExposurePlaceholder.jsx";
import RiskExposureList from "../../components/cards/data-card/1-RiskExposureList-Ip.jsx";
import Vulnerabilities from "../../components/cards/score-card/0-vulnerabilities.jsx";
import CriticalVul from "../../components/cards/score-card/1-critical-vulnerability.jsx";
import SaveScore from "../../components/cards/score-card/5-save-score.jsx";
import OpenPorts from "../../components/cards/score-card/2-open-ports.jsx";
import PieChartGraph from "./PieChart.jsx";
import EpssCard from "../../components/cards/data-card/3-epss-card.jsx";

const ScanView = () => {
  const { user } = useAuth();
  const { bHeightVal, zoom } = useDesign();
  const { showEpssCard } = useProfile();
  const {
    networkResults, currentIndex,
    TVulScore, CVulScore, saveScore,
    loadNetworkData,
    ipVulTable, ipEpssTable, ipServices,
    resetState
  } = useNetwork();    
  const props = { 
    bHeightVal, ipVulTable,
    assets: networkResults, saveScore 
  };
  const [preload, setPreload] = useState(true);
  
  useEffect(() => {
    const timeout = setTimeout(() => {
      setPreload(false);
    }, 1000);
    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (user) {
          await loadNetworkData(currentIndex);
        } else {
          resetState();
        }
      } catch (error) {
        console.error('Error in loadNetworkData:', error);
      }
    };
    fetchData();
  }, [currentIndex]);
  
  return (
    <div style={{ zoom: zoom }}>
      {showEpssCard && <EpssCard epssTable={ipEpssTable} />}
      <div className="bg-success text-light rounded-3 p-1 ps-2 my-2 ms-2 me-2">
        <div>
          Scanned Mac: <b>{networkResults[currentIndex]?.mac_address || ''}</b>
        </div>
      </div>
      <div className='d-flex justify-content-left'>
        {preload? <RiskExposureListPlaceholder /> : <RiskExposureList {...props} /> }
        <div style={{ height: bHeightVal }}>
          <div className='d-flex flex-row h-auto'>
            <div className='d-flex flex-column'>
              <Vulnerabilities score={TVulScore}/>
              <CriticalVul score={CVulScore}/>
            </div>
            <div className='d-flex flex-column'>
              <SaveScore setScore={saveScore}/>
              <OpenPorts services={ipServices}/>
            </div>
          </div>
          <PieChartGraph />
        </div> 
      </div>
    </div>
  );
};

export default ScanView;